import {
    addFileAttachment,
    addItemAttachment,
    removeAttachment,
    getAttachments,
    addFileAttachmentFromBase64,
    getAttachmentContent,
} from './attachmentAdapter';
import {
    addCategoriesMailbox,
    removeCategoriesMailbox,
    getCategoriesMailbox,
    getCategoriesItem,
    addCategoriesItemCompose,
    removeCategoriesItemCompose,
} from '../common/categoriesAdapter';
import {
    getBody,
    getBodyType,
    prependBody,
    setBody,
    setBodySelectedData,
    appendOnSend,
} from './bodyAdapter';
import { closeItem } from './closeAdapter';
import { getFrom } from './fromAdapter';
import { getItemId } from './itemIdAdapter';
import { getLocation, setLocation } from './locationAdapter';
import { addRecipients, getRecipients, setRecipients } from './recipientsAdapter';
import { saveItem } from './saveAdapter';
import { getSubject, setSubject } from './subjectAdapter';
import { getEndTime, getStartTime, setEndTime, setStartTime } from './timeAdapter';
import checkItemId from '../common/checkItemIdAdapter';
import { displayAppointmentForm } from '../common/displayAppointmentFormAdapter';
import displayMessageForm from '../common/displayMessageFormAdapter';
import { isRemoteItem, isSharedItem } from '../common/sharedItemAdapter';
import { getSharedProperties } from '../common/sharedPropertiesAdapter';
import { closeTaskPane, openTaskPane } from './composeTaskPaneUtils';
import { AppointmentComposeAdapter, getComposeHostItemIndex } from 'owa-addins-core';
import { ExtensibilityModeEnum } from 'owa-addins-types';
import type { FullComposeViewState } from 'owa-calendar-compose-types';
import getFullComposeViewState from 'owa-calendar-compose-form-store/lib/selectors/getFullComposeViewState';
import { getComposeEvent } from 'owa-calendar-compose-store-manager';
import { getSelectedData, setSelectedData } from './selectedDataAdapter';
import {
    addNotificationMessage,
    removeNotificationMessage,
    getNotificationMessageIds,
} from '../notifications/notificationsAdapter';
import {
    getTimeZone,
    setRecurrence,
    getTimeZoneName,
    setTimeZoneName,
    getRecurrence,
    getSeriesIdCompose,
} from '../common/recurrenceAdapter';
import {
    setSessionDataState,
    getSessionDataState,
    getAllSessionDataState,
    clearSessionDataState,
    removeSessionDataState,
} from './sessionDataAdapter';
import { addEnhancedLocations, removeEnhancedLocations } from './enhancedLocationsAdapter';
import { getEnhancedLocations } from '../common/getEnhancedLocationsAdapter';

let isAddinPinned = (addinId: string): boolean => {
    return false;
};

export default function createAppointmentComposeAdapter(): AppointmentComposeAdapter {
    const viewState: FullComposeViewState = getFullComposeViewState();
    if (!viewState) {
        // viewState is null if initialization of view state has not been completed.
        // This might happen in deeplink scenario when scripts are still downloading
        return null;
    }

    const event = getComposeEvent(null /* formId */);

    return {
        getRecipients,
        setRecipients,
        addRecipients,
        getSubject,
        setSubject,
        getLocation,
        setLocation,
        getItemId,
        getConversationId: null,
        getBody: getBody(viewState.bodyViewState),
        setBody: setBody(viewState.bodyViewState),
        getBodyType,
        prependBody: prependBody(viewState.bodyViewState),
        getSelectedData: getSelectedData(viewState),
        setSelectedData: setSelectedData(viewState),
        setBodySelectedData: setBodySelectedData(viewState.bodyViewState),
        mode: ExtensibilityModeEnum.AppointmentOrganizer,
        getStartTime,
        setStartTime,
        getEndTime,
        setEndTime,
        openTaskPane: openTaskPane(ExtensibilityModeEnum.AppointmentOrganizer),
        closeTaskPane: closeTaskPane(ExtensibilityModeEnum.AppointmentOrganizer),
        addItemAttachment: addItemAttachment(viewState),
        addFileAttachment: addFileAttachment(viewState),
        addFileAttachmentFromBase64: addFileAttachmentFromBase64(viewState),
        removeAttachment: removeAttachment(viewState),
        getAttachments: getAttachments(viewState),
        getAttachmentContent: getAttachmentContent(viewState),
        saveItem: saveItem,
        addNotificationMessage: addNotificationMessage(
            getComposeHostItemIndex(event.ParentFolderId.Id),
            viewState,
            event.ParentFolderId.Id
        ),
        removeNotificationMessage: removeNotificationMessage(viewState, event.ParentFolderId.Id),
        getNotificationMessageIds: getNotificationMessageIds(viewState),
        close: closeItem,
        displayMessageForm,
        checkItemId,
        displayAppointmentForm,
        isAddinPinned,
        getFrom,
        isSharedItem: isSharedItem(event),
        isRemoteItem: isRemoteItem(event),
        getRecurrence: getRecurrence(event),
        setRecurrence,
        getSharedProperties: getSharedProperties(event),
        getTimeZone,
        setTimeZoneName,
        getTimeZoneName,
        getSeriesId: getSeriesIdCompose,
        getEnhancedLocations: getEnhancedLocations(event),
        addEnhancedLocations,
        removeEnhancedLocations,
        getCategoriesMailbox: getCategoriesMailbox(event),
        addCategoriesMailbox: addCategoriesMailbox,
        removeCategoriesMailbox: removeCategoriesMailbox,
        getCategoriesItem: getCategoriesItem(event),
        addCategoriesItemCompose: addCategoriesItemCompose(),
        removeCategoriesItemCompose: removeCategoriesItemCompose(),
        appendOnSend: appendOnSend(viewState),
        setSessionDataState: setSessionDataState(viewState),
        getSessionDataState: getSessionDataState(viewState),
        getAllSessionDataState: getAllSessionDataState(viewState),
        clearSessionDataState: clearSessionDataState(viewState),
        removeSessionDataState: removeSessionDataState(viewState),
    };
}
